import { LoadingState } from "@/shared/layout";

export function LoadingScreen() {
  return (
    <div data-theme="accela-donutwork" className="min-h-screen bg-base-200">
      <LoadingState label="Loading workspace…" />
    </div>
  );
}
